const pricyByCurrency = (abbr) => {
  if (abbr === 'GBP' || abbr === 'CHF') {
    return 100;
  } if (abbr === 'USD') {
    return 100;
  }
  return 135;
};

export default function planTotal({ plan, membersCovered, billingType }) {
  let newTotal = 0;
  const pricePerEmployee = plan.attributes.price_employee_month;
  if (membersCovered !== undefined && membersCovered !== '') {
    newTotal = membersCovered * pricePerEmployee;
  }

  if (plan && plan.attributes.rules) {
    plan.attributes.rules.forEach((rule) => {
      if (rule.type === 'price_minimal') {
        const minimalPrice = pricyByCurrency(plan.attributes.currency.title);
        if (newTotal < minimalPrice) {
          newTotal = minimalPrice;
        }
      }
    });
  }

  plan.attributes.monthly_custom_records.forEach((item) => {
    newTotal += Number(item.price);
  });
  if (plan.attributes.monthly_discount_enable) {
    const discount = (100 - Number(plan.attributes.monthly_discount)) / 100;
    newTotal *= discount;
  }
  if (billingType === 'annual') {
    if (plan.attributes.annual_discount !== '') {
      const annualDiscount = (100 - Number(plan.attributes.annual_discount)) / 100;
      newTotal *= annualDiscount;
    }
  }

  return newTotal.toFixed(2);
}
